export function rolesResource(data) {
    return {
        id: data.id,
        name: data.name
    };
}
export function routesResource(data) {
    return {
        name: data.name,
        available: data.available
    };
}
